import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { NcrsPage } from '@/features/quality/ncrs-page';

const searchSchema = z.object({
  ncr: z.string().optional().catch(undefined),
  new: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/quality/ncrs')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <NcrsPage projectId={projectId} ncrId={search.ncr} create={search.new} />;
}
